import React from 'react'

import { cn } from '@/lib/cn'

const UserCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex w-full items-center justify-between gap-2 rounded-lg bg-system-primary-purple/10 p-2',
        className,
      )}
      {...props}
    />
  )
})
UserCard.displayName = 'UserCard'

const UserCardProfile = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('flex items-center gap-2', className)}
      {...props}
    />
  )
})
UserCardProfile.displayName = 'UserCardProfile'

const UserCardProfileHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('flex flex-col gap-1', className)}
      {...props}
    />
  )
})
UserCardProfileHeader.displayName = 'UserCardProfileHeader'

const UserCardName = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        'text-ellipsis text-sm font-medium text-system-text-primary',
        className,
      )}
      {...props}
    />
  )
})
UserCardName.displayName = 'UserCardName'

const UserCardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(
        'text-ellipsis text-xs font-normal text-system-text-secondary',
        className,
      )}
      {...props}
    />
  )
})
UserCardDescription.displayName = 'UserCardDescription'

export {
  UserCard,
  UserCardProfile,
  UserCardProfileHeader,
  UserCardName,
  UserCardDescription,
}
